import { memo, ReactElement } from 'react';
import { AutocompleteInput, AutocompleteInputProps, ReferenceInput, ReferenceInputProps, SelectInput, SelectInputProps, useResourceContext } from 'react-admin';
import EmailTemplate from '../GeneratedModels/EmailTemplate';
import ReferenceQuickCreateInput from '../react-admin/ReferenceQuickCreateInput';

/**
 * Generated by Db2Ts @ 2023-06-12 15:11:1148
 */

interface EmailTemplateSelectInputProps extends Omit<SelectInputProps, "optionText"> {
  optionText: 'id' | 'alias' | 'title' | 'subject_en' | 'subject_tc' | 'subject_sc' | 'content_en_html' | 'content_tc_html' | 'content_sc_html' | 'footer_type' | 'footer_en_html' | 'footer_tc_html' | 'footer_sc_html' | 'active_status' | 'sender_name' | 'sender_email' | 'reply_to_email' | 'cc_email_type' | 'cc_email_array' | 'bcc_email_type' | 'bcc_email_array' | 'created' | 'createdBy' | 'updated' | 'updatedBy' | ((data: EmailTemplate) => string),
}

interface EmailTemplateAutocompleteInputProps extends Omit<AutocompleteInputProps, "optionText"> {
  optionText: keyof EmailTemplate | ((data: EmailTemplate) => string),
  filterProps: Array<keyof EmailTemplate>,
}

interface EmailTemplateReferenceInputProps extends Omit<ReferenceInputProps, 'source' | 'reference' | 'children'> {
  source?: string,
  reference?: string,
  selectInputProps?: EmailTemplateSelectInputProps,
  autocompleteInputProps?: EmailTemplateAutocompleteInputProps,
  filter?: Partial<EmailTemplate>,
  useAutocomplete?: boolean,

  quickCreate?: {
    fields?: ReactElement,
    formElements?: ReactElement,
  }
}

function EmailTemplateReferenceInput({ label, source, reference, selectInputProps, useAutocomplete, autocompleteInputProps, quickCreate, validate, name, ...rest }: EmailTemplateReferenceInputProps) {
  const resource = useResourceContext();
  label = label ?? `resources.${resource}.fields.${source}`
  return (
    quickCreate
      ? <ReferenceQuickCreateInput selectInputProps={selectInputProps as any} {...rest} {...quickCreate} source={source ?? "email_template_id"} reference={reference ?? "email_template"} />
      : <ReferenceInput {...rest} source={source ?? "email_template_id"} reference={reference ?? "email_template"} label={label}>
        {useAutocomplete && autocompleteInputProps
          ? <AutocompleteInput filterToQuery={q => ({ __mode: 'filterToQuery', ...(Object.fromEntries(autocompleteInputProps.filterProps.map(x => [x, q]))) })} {...autocompleteInputProps}/>
          : <SelectInput disabled={rest.disabled} {...selectInputProps} fullWidth validate={validate} name={name} label={label} />
        }
      </ReferenceInput>
  )
}

EmailTemplateReferenceInput.defaultProps = {
  addLabel: true,
  fullWidth: true,
  // label: "EmailTemplate",
  source: "email_template_id",
  reference: "email_template",
  selectInputProps: {
    optionText: 'alias',
  },
  autocompleteInputProps: {
    optionText: 'alias',
    filterProps: ['alias'],
  }
};

export default memo(EmailTemplateReferenceInput);
